import React from "react";
import { ITabs } from "apps/website/components/feature/Tabs/shared/types";

import { RecipeContentVariant } from "../components/RecipeContentVariant";

export const recipeComparisonKatkinVariantData: ITabs = {
  tabs: [
    {
      key: "1",
      title: "Cluck",
      Panel: {
        title: "100% fresh\n`Chicken`",
        Content: <RecipeContentVariant imageKey="cluck" />,
        theme: "orange",
      },
    },
    {
      key: "2",
      title: "Gobble",
      Panel: {
        title: "100% fresh\n`Turkey`",
        subtitle: "+ Chicken",
        Content: <RecipeContentVariant imageKey="gobble" />,
      },
    },
    {
      key: "3",
      title: "Mooo",
      Panel: {
        title: "100% fresh\n`Beef`",
        Content: <RecipeContentVariant imageKey="mooo" />,
        theme: "orange",
      },
    },
    {
      key: "4",
      title: "Quack",
      Panel: {
        title: "100% fresh\n`Duck`",
        subtitle: "+ Chicken",
        Content: <RecipeContentVariant imageKey="quack" />,
        theme: "green",
      },
    },
    {
      key: "5",
      title: "Baaa",
      Panel: {
        title: "100% fresh\n`Lamb`",
        Content: <RecipeContentVariant imageKey="baaa" />,
        theme: "red",
      },
    },
    {
      key: "6",
      title: "Oink",
      Panel: {
        title: "100% fresh\n`Pork`",
        Content: <RecipeContentVariant imageKey="oink" />,
        theme: "pink",
      },
    },
    {
      key: "7",
      title: "Splash",
      Panel: {
        title: "100% fresh\n`Fish`",
        subtitle: "+ Turkey",
        Content: <RecipeContentVariant imageKey="splash" />,
        theme: "blue",
      },
    },
    {
      key: "8",
      title: "Swish",
      Panel: {
        title: "100% fresh\n`Fish`",
        subtitle: "+ Chicken",
        Content: <RecipeContentVariant imageKey="swish" />,
        theme: "light-blue",
      },
    },
  ],
  defaultActiveTab: "1",
};
